<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.app_client_id"
        placeholder="客户端"
        clearable
        filterable
        style="width: 220px"
        class="filter-item"
        size="small"
      >
        <el-option
          v-for="appClient in appClientList"
          :label="appClient.name"
          :value="appClient.id"
          :key="appClient.id"
        />
      </el-select>
      订单时间:
      <el-date-picker
        size="small"
        class="filter-item"
        v-model="dateArr"
        type="daterange"
        :default-time="['00:00:00', '23:59:59']"
        align="right"
        value-format="yyyy-MM-dd"
        unlink-panels
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
      />
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        size="small"
        >搜索
      </el-button>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      size="small"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="客户名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="客户ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="今日营业额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.today_sales }}
        </template>
      </el-table-column>
      <el-table-column label="昨日营业额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.yesterday_sales }}
        </template>
      </el-table-column>
      <el-table-column label="营业总额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.sales }}
        </template>
      </el-table-column>
      <el-table-column label="今日下单数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.today_order_num }}
        </template>
      </el-table-column>
      <el-table-column label="昨日下单数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.yesterday_order_num }}
        </template>
      </el-table-column>
      <el-table-column label="总下单数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_num }}
        </template>
      </el-table-column>
      <el-table-column label="退单率%" min-width="110" align="center">
        <template slot-scope="scope">
          {{ (scope.row.refund_order_rate * 100).toFixed(2) }}%
        </template>
      </el-table-column>
      <el-table-column label="预定成功率%" min-width="110" align="center">
        <template slot-scope="scope">
          {{ (scope.row.booking_success_rate * 100).toFixed(2) }}%
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        size="small"
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        app_client_id: '',
      },
      dateArr: null,
      appClientList: [],
    }
  },
  created() {
    this.getAppClientList()
    this.getList()
  },
  watch: {
    dateArr(newVal) {
      if (newVal) {
        this.listQuery.start_at = newVal[0] + ' 00:00:00'
        this.listQuery.end_at = newVal[1] + ' 23:59:59'
      } else {
        this.listQuery.start_at = ''
        this.listQuery.end_at = ''
      }
    },
  },
  methods: {
    getAppClientList() {
      request({
        url: '/api/backend/app-client/list',
        method: 'get',
        params: {
          limit: 9999999,
        },
      }).then((response) => {
        this.appClientList = response.data.data
      })
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/dataCount/appClientList',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
::v-deep .el-date-editor .el-range-separator {
  width: 8%;
}
</style>
